import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserContextService } from '../services/user-context.service';
import { AuthService } from '../services/auth.service';
import { AuthNavigationService } from '../services/auth-navigation.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private userContext: UserContextService,
    private authService: AuthService,
    private authNav: AuthNavigationService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      await this.authService.ensureAuthenticatedAsync();

      if (!this.authService.getIsAuthenticated()) {
        this.authNav.navigateToHome();
        return false;
      }

      if (!this.authService.hasAccess()) {
        this.authNav.navigateToNotAuthorizedPermissions();
        return false;
      }

      if (!this.userContext.sourceId && !this.userContext.shouldShowTenantSelection) {
        await this.userContext.initializeAsync();
      }

      if (this.userContext.hasNoTenants) {
        this.authNav.navigateToNotAuthorizedNoTenants();
        return false;
      }

      if (this.userContext.sourceId === null) {
        if (this.userContext.shouldShowTenantSelection) {
          this.authNav.navigateToAssociationSelection();
        } else {
          this.authNav.navigateToHome();
        }
        return false;
      }

      return true;
    } catch {
      this.authNav.navigateToHome();
      return false;
    }
  }
}
